export const GET_ADMIN_REFUND_REASON = "GET_ADMIN_REFUND_REASON"
export const GET_ADMIN_REFUND_REASON_SUCCESS = "GET_ADMIN_REFUND_REASON_SUCCESS"
export const GET_ADMIN_REFUND_REASON_ERROR = "GET_ADMIN_REFUND_REASON_ERROR"

export const POST_ADMIN_REFUND_REASON = "POST_ADMIN_REFUND_REASON"
export const POST_ADMIN_REFUND_REASON_SUCCESS = "POST_ADMIN_REFUND_REASON_SUCCESS"
export const POST_ADMIN_REFUND_REASON_ERROR = "POST_ADMIN_REFUND_REASON_ERROR"

export const UPDATE_ADMIN_REFUND_REASON = "UPDATE_ADMIN_REFUND_REASON"
export const UPDATE_ADMIN_REFUND_REASON_SUCCESS = "UPDATE_ADMIN_REFUND_REASON_SUCCESS"
export const UPDATE_ADMIN_REFUND_REASON_ERROR = "UPDATE_ADMIN_REFUND_REASON_ERROR"

export const DELETE_ADMIN_REFUND_REASON = "DELETE_ADMIN_REFUND_REASON"
export const DELETE_ADMIN_REFUND_REASON_SUCCESS = "DELETE_ADMIN_REFUND_REASON_SUCCESS"
export const DELETE_ADMIN_REFUND_REASON_ERROR = "DELETE_ADMIN_REFUND_REASON_ERROR"

